import {push} from 'connected-react-router';

export const actionCreators = {
    navigate: (path) => async (dispatch, getState) => {
        dispatch(push(path));
    }
}